import {StyledAnchor, StyledLink} from './StyledTypeDefinitions'
import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {Link} from 'react-router-dom'
import {Colors, FontSize, FontWeights, LineHeight} from './Constants'

export const UnstyledLink: StyledLink = styled(Link)`
  color: ${Colors.Body};
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: transparent;
`

export const PlainLink = styled(UnstyledLink)`
  color: ${Colors.Primary};

  margin: 1rem;

  display: block;
  box-sizing: border-box;

  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};

  line-height: 1.6rem;
  text-align: center;
  vertical-align: center;
`

export const backArrow: FlattenSimpleInterpolation = css`
  position: absolute;
  content: '';
  width: 0.8rem;
  height: 0.8rem;
  border-top: solid 2px ${Colors.Primary};
  border-left: solid 2px ${Colors.Primary};
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 50%;
  left: 0;
  margin-top: -0.4rem;
`

export const GuestBackArrow: FlattenSimpleInterpolation = css`
  position: absolute;
  content: '';
  width: 0.8rem;
  height: 0.8rem;
  border-top: solid 2px ${Colors.GuestPrimary};
  border-left: solid 2px ${Colors.GuestPrimary};
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 50%;
  left: 0;
  margin-top: -0.4rem;
`

export const forwardArrow: FlattenSimpleInterpolation = css`
  position: absolute;
  content: '';
  width: 0.8rem;
  height: 0.8rem;
  border-top: solid 2px ${Colors.Primary};
  border-right: solid 2px ${Colors.Primary};
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  top: 50%;
  right: 0;
  margin-top: -0.4rem;
`

export const PlainBackLink = styled(PlainLink)`
  display: inline-block;
  position: relative;
  padding-left: 15px;
  margin: 0;

  :before {
    ${backArrow};
  }
`

export const PlainForwardLink = styled(PlainLink)`
  display: inline-block;
  position: relative;
  padding-right: 15px;
  margin: 0;

  :after {
    ${forwardArrow};
  }
`

export const PrimaryButtonStyledLink = styled(PlainLink)<{ disabled?: boolean }>`
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 50px;
  min-height: 50px;
  width: 100%;
  max-width: 384px;

  border: 1px solid ${Colors.Primary};
  border-radius: 8px;

  font-weight: ${FontWeights.Bold};
  color: ${Colors.Surface};
  background-color: ${Colors.Primary};

  box-shadow: 0 2px 0 0 ${Colors.PrimaryVariant};

  :active {
    background-color: ${Colors.PrimaryActive};
    box-shadow: none;
  }

  ${props => props.disabled && `
    pointer-events: none;
    border: none;
    background-color: ${Colors.AccentLight};
    box-shadow: none;
  `};
`

export const SecondaryButtonStyledLink = styled(PlainLink)`
  margin: 2rem 0;
  height: 5rem;

  border: .1rem solid rgba(0, 112, 176, 0.5);
  border-radius: .8rem;
  box-shadow: none;

  padding: 1.7rem 0;

  :active {
    background-color: ${Colors.SecondaryActive};
  }
`

export const SmallSecondaryButtonStyledLink = styled(SecondaryButtonStyledLink)`
  margin-left: auto;
  margin-right: auto;
  width: 31.5rem;
`

export const SmallPlainLink = styled(PlainLink)`
  margin: 0;
  display: inline-block;
  font-size: ${FontSize.Body};
  line-height: ${LineHeight.Basic};
  text-align: left;
`

export const PlainAncerLink: StyledAnchor = styled.a`
  color: ${Colors.Primary};
  margin: 0;
  display: inline-block;
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};
  line-height: ${LineHeight.Basic};
  text-align: center;
  vertical-align: center;
`
